import {
  GET_REMITFX_TRANSFER_FORM,
  GET_REMITFX_TRANSFER_FORM_SUCCESS,
  GET_REMITFX_TRANSFER_FORM_FAIL,
  VERIFY_REMITFX_FORM,
  VERIFY_REMITFX_FORM_SUCCESS,
  VERIFY_REMITFX_FORM_FAIL,
  SUBMIT_REMITFX_FORM,
  SUBMIT_REMITFX_FORM_SUCCESS,
  SUBMIT_REMITFX_FORM_FAIL,
  UPDATE_REMITFX_FILLED_DATA,
  RESET_REMITFX_FILLED_DATA,
  REMOVE_REMITFX_FORM_ERROR
} from "../Assets/Constant/RemitFXTransferForm";
import getTransformedPayload from "./utils/payloadTransformer";

const initialState = {
  loading: false,
  data: [],
  filledData: {},
  field_group: [],
  error: null,
};

const remitfxFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_REMITFX_FILLED_DATA:
      const transformedPayload = getTransformedPayload({filledData: state.filledData, updatedData: action.data});
      return {
        ...state,
        filledData: transformedPayload
      }
    case RESET_REMITFX_FILLED_DATA:
      return {
        ...state,
        filledData: {}
      }
    case GET_REMITFX_TRANSFER_FORM:
      return {
        ...state,
        loading: true,
      };
    case GET_REMITFX_TRANSFER_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        field_group: [...new Set(action.data.fields.map((data) => data.field_group))],
        data: action.data.fields,
      };
    case GET_REMITFX_TRANSFER_FORM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    case REMOVE_REMITFX_FORM_ERROR:
      return state;
    case VERIFY_REMITFX_FORM:
      return {
        ...state,
        loading: true,
      };
    case VERIFY_REMITFX_FORM_SUCCESS:
      return {
        ...state,
        data: state.data.map(obj => action.data.changes.find(o => o.name === obj.name) || obj),
        loading: false,
      };
    case VERIFY_REMITFX_FORM_FAIL:
      const newData = state.data.map(obj => action.data.changes.find(o => o.name === obj.name) || obj);
      const newDataWithErrors = newData.map(obj => {
        let result = action.errors.filter(id => obj.name === id.name);
        if (result.length > 0) {
          return {
            ...obj,
            messages: result[0].messages,
            error: true
          }
        }
        return obj;
      })
      return {
        ...state,
        data: newDataWithErrors,
        loading: false,
      };
    case SUBMIT_REMITFX_FORM:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_REMITFX_FORM_SUCCESS:
      return {
        ...state,
        loading: true,
      };
    case SUBMIT_REMITFX_FORM_FAIL:
      return {
        ...state,
        data: state.data.map(obj => {
          let result = action.errors.filter(id => obj.name === id.name);
          if (result.length > 0) {
            return {
              ...obj,
              messages: result[0].messages,
              error: true
            }
          }


          return obj;
        }),
        loading: false,
      };
    default:
      return state;
  }
};

export default remitfxFormReducer;
